import { createContext, useContext, useState } from "react";

// Override locali delle foto profilo (per utente). Futuro: upload su object storage.
const AvatarContext = createContext(null);
const KEY = "aesthetic-os-avatars";

const load = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
};

export function AvatarProvider({ children }) {
  const [avatars, setAvatars] = useState(load);

  const persist = (next) => {
    localStorage.setItem(KEY, JSON.stringify(next));
    setAvatars(next);
  };
  const setAvatar = (userId, dataUrl) => persist({ ...avatars, [userId]: dataUrl });
  const removeAvatar = (userId) => {
    const next = { ...avatars };
    delete next[userId];
    persist(next);
  };
  const avatarFor = (userId, fallback) => avatars[userId] || fallback;

  return (
    <AvatarContext.Provider value={{ avatars, setAvatar, removeAvatar, avatarFor }}>
      {children}
    </AvatarContext.Provider>
  );
}

export const useAvatars = () => useContext(AvatarContext);
